import { Box, MenuItem as MuiMenuItem, Radio as MuiRadio } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
    margin-bottom: 16px;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`

export const MenuItem = styled(MuiMenuItem)`
  ${({ theme }) => css`
    font-size: 14px;
    color: ${theme.colors.secondary};
    height: 48px;
    padding: 12px 41px;

    display: flex;
    align-items: center;
    gap: 8px;

    &:hover,
    &:focus,
    &.Mui-selected {
      background-color: ${theme.colors.lightest} !important;
    }
  `}
`

export const Radio = styled(MuiRadio)`
  ${({ theme }) => css`
    padding: 0;
    margin: 0;
    align-items: center;
    justify-content: center;

    .MuiSvgIcon-root {
      font-size: 24px;
    }

    color: ${theme.colors.secondary};

    &.Mui-checked {
      color: ${theme.colors.secondary};
    }
  `}
`

export const RadioText = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;

  svg {
    margin-top: 4px;
  }
`

export const DateBox = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`
